import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      '& h2': {
        margin: theme.spacing(1.5, 0),
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightBold,
      },
    },
  })
);

export default useStyles;
